import { render, staticRenderFns } from "./LessonNoteAttachmentsSection.vue?vue&type=template&id=c43d1728&"
import script from "./LessonNoteAttachmentsSection.vue?vue&type=script&lang=ts&"
export * from "./LessonNoteAttachmentsSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports